
export  {images}

const images = 
   [

    {
      alt: "Entrée du gîte",
      src: "./assets/imgHaute/haute1.webp",
      title: "Entrée du gîte"
    },
    {
      alt: "Cuisine du gîte",
      src: "./assets/imgHaute/haute2.webp",
      title: "Cuisine du gîte"
    },
    {
      alt: "Cuisine du gîte",
      src: "./assets/imgHaute/haute3.webp",
      title: "Cuisine du gîte"
    },
    {
      alt: "Cuisine du gîte",
      src: "./assets/imgHaute/haute4.webp",
      title: "Cuisine du gîte"
    },
    {
      alt: "Cuisine du gîte",
      src: "./assets/imgHaute/haute5.webp",
      title: "Cuisine du gîte"
    },
    {
      alt: "Cuisine du gîte",
      src: "./assets/imgHaute/haute6.webp",
      title: "Cuisine du gîte"
    },
    {
      alt: "Chambre avec un lit",
      src: "./assets/imgHaute/haute7.webp",
      title: "Chambre avec un lit"
    },
    {
      alt: "Chambre avec un lit",
      src: "./assets/imgHaute/haute8.webp",
      title: "Chambre avec un lit"
    },
    {
      alt: "Chambre avec un lit",
      src: "./assets/imgHaute/haute9.webp",
      title: "Chambre avec un lit"
    },
    {
      alt: "Salle de bain avec douche à l'italienne",
      src: "./assets/imgHaute/haute10.webp",
      title: "Salle de bain avec douche à l'italienne"
    },
    {
      alt: "Terrasse",
      src: "./assets/imgHaute/haute11.webp",
      title: "Terrasse"
    },
    {
      alt: "Terrasse",
      src: "./assets/imgHaute/haute12.webp",
      title: "Terrasse"
    },
    {
      alt: "Terrasse",
      src: "./assets/imgHaute/haute13.webp",
      title: "Terrasse"
    }
    
  ];
  export default images;